<template>
  <div>
    <core-modal-header>Merge Tags?</core-modal-header>

    <core-modal-body>
      <p class="text-xl text-center">Are you sure you want to merge...</p>
      <div class="flex justify-center gap-8 my-8">
        <div class="w-2/5 max-w-2/5">
          <tag-list-item
            :tag="tag"
            disable-edit
            hide-context-menu
            :selectable="false"
            class="h-full"
          />
        </div>

        <u-divider label="into" icon="i-ri-arrow-right-line" orientation="vertical" :ui="{label: 'text-lg font-semibold'}" />

        <div class="w-2/5 max-w-2/5">
          <tag-list-item
            :tag="toTag"
            disable-edit
            hide-context-menu
            :selectable="false"
            class="h-full"
          />
        </div>
      </div>

      <u-alert color="red" variant="subtle" :icon="COMMON_ICONS.information">
        <template #title>This action cannot be undone.</template>
        <template #description>
          Merging <span class="italic font-semibold">{{tag.name}}</span> into <span class="italic font-semibold">{{toTag.name}}</span> will break any share link of QR code previously associated with <span class="italic font-semibold">{{tag.name}}</span>.
        </template>
      </u-alert>
    </core-modal-body>

    <core-modal-footer>
      <u-button size="xl" color="charcoal" variant="soft" @click="modal.close()">Cancel</u-button>
      <u-button size="xl" :loading="isMerging" @click="merge">Merge Tags</u-button>
    </core-modal-footer>
  </div>
</template>

<script setup>
  const emit = defineEmits(['success']);
  const props = defineProps({
    tag: Object,
    toTag: Object,
    modal: Object
  });

  const tagsStore = useTagsStore();
  const isMerging = ref(false);

  async function merge() {
    isMerging.value = true;
    try {
      await tagsStore.mergeTags({
        source: props.tag,
        destination: props.toTag
      });

      props.modal.close();

      emit('success');
    } catch (e) {
      useErrorToast().add();
    } finally {
      isMerging.value = false;
    }
  }

</script>
